import { render, staticRenderFns } from "./video-box.vue?vue&type=template&id=3f7b7ee5"
import script from "./video-box.vue?vue&type=script&lang=js"
export * from "./video-box.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports